// NOTE: The below variables should be in sync with the respective `.env`s variables

export const environmentsEndPointsURLs = [
   {
      envName: 'alpha',

      loginClientId: 'v04VgUKAQk2PqW5G0pXWMI0ocH9XEwSlkoWppG8f',
      URLs: {
         restBaseURL: 'https://crm-apis-alpha.flowwlabs.tech/',
         graphqlBaseURL: 'https://crm-apis-alpha.flowwlabs.tech/graphql/',
         graphqlSubscriptionURL: 'https://crm-alpha-gql.flowwlabs.tech/graphql'
      }
   },
   {
      envName: 'beta',

      loginClientId: 'qjeonGF5LSywS8jC0OUrNkIKR4wYygBMUFijd2NR',
      URLs: {
         restBaseURL: 'https://crm-apis-beta.flowwlabs.tech/',
         graphqlBaseURL: 'https://crm-apis-beta.flowwlabs.tech/graphql/',
         graphqlSubscriptionURL: 'https://crm-beta-gql.flowwlabs.tech/graphql'
      }
   },
   {
      envName: 'gamma',

      loginClientId: 'SEcufsnHiqIKcS9JMVblXIiaJKCuL9jUTpHmi91C',
      URLs: {
         restBaseURL: 'https://crm-apis-gamma.flowwlabs.tech/',
         graphqlBaseURL: 'https://crm-apis-gamma.flowwlabs.tech/graphql/',
         graphqlSubscriptionURL: 'https://crm-gamma-gql.flowwlabs.tech/graphql'
      }
   },
   {
      envName: 'bn gamma',
      loginClientId: 'SEcufsnHiqIKcS9JMVblXIiaJKCuL9jUTpHmi91C',
      URLs: {
         restBaseURL: 'https://gamma-fw-bn-server.flowwlabs.tech/',
         graphqlBaseURL: 'https://gamma-fw-bn-server.flowwlabs.tech/graphql/',
         graphqlSubscriptionURL:
            'https://tg-build-now-gamma-gql.flowwlabs.tech/graphql'
      }
   }
]
